<script type="text/jsx">
import BuyNow from './buy-now';
import Edit from './edit.vue';
import Add from "./add2cart";
import Upgrade from './upgrade.vue';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['migratePlanState']),
  },
  render() {
    const context = { ...{ props: { ...this.$attrs }, on: { ...this.$listeners } } };
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...context} />;
    if (this.$context.is.edit || this.migratePlanState.is.upgrade) {
      if (this.migratePlanState.is.upgrade) return <Upgrade {...context} />;
      return <Edit {...context} />;
    }
    if (this.$context.is.add2cart) return <Add {...context} />;
    return null;
  },
};
</script>
